import { render } from "./ImportListCustomers.vue?vue&type=template&id=3cbc94ea&scoped=true"
import script from "./ImportListCustomers.vue?vue&type=script&lang=ts"
export * from "./ImportListCustomers.vue?vue&type=script&lang=ts"

import "./ImportListCustomers.vue?vue&type=style&index=0&id=3cbc94ea&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3cbc94ea"

export default script